import React from "react";
import {Button, notification, Input, Typography, Divider} from "antd";
import {LoadingOutlined, MailOutlined, UserOutlined} from '@ant-design/icons'
import logo from '../assets/img 900x900.png'
import '../styles/LandingView.css'
import {Auth} from "@q4us-sw/q4us-ui";
import {resetPassword} from "../api/api";


export const LandingView = (props)=>{
    const [state,setState] = React.useState({})
    return <div className={`landing-root`}>
        <div className={"landing-description"}>
            <img src={logo} className={'landing-logo'}/>
        </div>
        <div className={`sign-in-wrap`}>
            <div className={`sign-in-title`}>

                {
                    <React.Fragment>
                        <div className={`title`}><Typography.Title>Sign In</Typography.Title></div>
                        <div className={`subtitle`}><Typography.Title level={5} disabled>Sign in to continue to EAS portal</Typography.Title></div>

                        <div className={"sign-in-input"}>
                            <Input value={state.userName} suffix={<UserOutlined/>} placeholder={`User Name`} onChange={(e)=>setState({...state, userName: e.target.value})}/>
                        </div>

                        <div  className={"sign-in-input"}>
                            <Input.Password placeholder={`Password`} value={state.password} onChange={(e)=>setState({...state, password: e.target.value})}/>
                        </div>
                        <div  className={"sign-in-input"}>
                            <Button onClick={async ()=>{
                                if(!state.userName)
                                    notification.warn({message: "User name required"})
                                else if(!state.password)
                                    notification.warn({message: "Password required"})
                                else{
                                    await Auth.signIn(state.userName, state.password)
                                    if(!Auth.token){
                                        notification.error({message: 'Unauthorized'})
                                    }
                                }
                            }}>Sign In</Button>
                        </div>
                        <div>
                            {(!state.forgotPw) && <Typography.Link onClick={() => {
                                setState({...state, forgotPw: true})
                            }}>Forgot Password?</Typography.Link>}
                            {state.forgotPw && <React.Fragment>
                                <Divider orientation={"center"}>Or</Divider>
                                <div className={"sign-in-input"}>
                                    <Input value={state.email} suffix={<MailOutlined/>}
                                           placeholder={`Email Address`}
                                           onChange={(e) => setState({...state, email: e.target.value})}/>
                                </div>
                                <div className={"sign-in-input"}>
                                    <Button icon={state.loading ? <LoadingOutlined/> : undefined} className={`ant-btn-dangerous`} onClick={async () => {
                                        if (!state.email)
                                            notification.warn({message: "User name required"})
                                        else {
                                            setState({...state, loading: true})
                                            try{
                                                const {status} = await resetPassword(state.email) || {}
                                                if(status === 200) {
                                                    setState({...state, forgotPw: false, email: undefined, loading: false})
                                                    notification.success({message: `Password reset link sent to the email address [${state.email}]`})
                                                }else
                                                    setState({...state, loading: false})
                                            }catch (e){
                                                setState({...state, loading: false})
                                            }

                                        }
                                    }}>Reset Password</Button>
                                </div>
                            </React.Fragment>}
                        </div>
                    </React.Fragment>
                }
            </div>
        </div>
    </div>
}
